module.exports = __webpack_public_path__ + "static/img/148_TO8_1861_og.fb7e09e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/148_TO8_1861_og.jpg
// module id = nAT6
// module chunks = 0